(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kmeconsulting-krydssalg"] && !Shopify.designMode) return;
  try {
    
  // Runs once per page, so everything is delegated from document and scoped
  // to the nearest [data-kme-xsell].
  document.addEventListener('change', function (e) {
    var picker = e.target.closest('[data-kme-xsell-variant]');
    if (!picker) return;
    var opt = picker.options[picker.selectedIndex];
    var price = picker.closest('.kme-xsell__card').querySelector('[data-kme-xsell-price]');
    if (opt && price && opt.getAttribute('data-price')) price.textContent = opt.getAttribute('data-price');
  });

  document.addEventListener('click', function (e) {
    var arrow = e.target.closest('[data-kme-xsell-scroll]');
    if (arrow) {
      var track = arrow.closest('[data-kme-xsell]').querySelector('[data-kme-xsell-track]');
      var card = track && track.firstElementChild;
      if (track && card) {
        var step = card.getBoundingClientRect().width + 16;
        track.scrollBy({ left: step * Number(arrow.getAttribute('data-kme-xsell-scroll')), behavior: 'smooth' });
      }
      return;
    }

    var btn = e.target.closest('[data-kme-xsell-add]');
    if (!btn || btn.disabled) return;

    // A card with a size picker adds the picked variant, not the default.
    var cardEl = btn.closest('.kme-xsell__card');
    var picker = cardEl && cardEl.querySelector('[data-kme-xsell-variant]');
    var variantId = picker ? picker.value : btn.getAttribute('data-variant-id');

    var root = btn.closest('[data-kme-xsell]');
    var errorEl = root ? root.querySelector('[data-kme-xsell-error]') : null;
    var label = btn.querySelector('.kme-xsell__add-label');
    var done = btn.querySelector('.kme-xsell__add-done');

    btn.disabled = true;
    if (errorEl) errorEl.hidden = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (j) {
            throw new Error(j.description || j.message || 'Kunne ikke lægges i kurven.');
          });
        }
        return res.json();
      })
      .then(function () {
        if (label) label.hidden = true;
        if (done) done.hidden = false;
        btn.classList.add('is-added');
        setTimeout(function () {
          if (label) label.hidden = false;
          if (done) done.hidden = true;
          btn.classList.remove('is-added');
          btn.disabled = false;
        }, 2200);

        // Same handshake as the front-page strip: Horizon's cart icon and
        // drawer listen for 'cart:update' and read itemCount from the cart.
        return fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            document.dispatchEvent(
              new CustomEvent('cart:update', {
                bubbles: true,
                detail: {
                  resource: cart,
                  sourceId: 'kme-xsell',
                  data: { source: 'kme-xsell', itemCount: cart.item_count },
                },
              })
            );
          })
          .catch(function () {});
      })
      .catch(function (err) {
        btn.disabled = false;
        if (errorEl) {
          errorEl.textContent = err.message || 'Noget gik galt — prøv igen.';
          errorEl.hidden = false;
        }
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
